let _ = require('ES/lib/lodash');
let dd = require('ES/lib/dd');
let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let MiniCalendar = require('./MiniCalendar');
let CalendarLegend = require("./CalendarLegend");

module.exports = dd.createClass({
  __incYear(inc) {
    let d = new Date(this.props.year, this.props.month - 1, 1);
    d.setFullYear(d.getFullYear() + inc);
    radio('Show_Calendar').broadcast('year', d);
  },
  __prevYear: esUtils.wrapPreventDefault(function () {
    this.__incYear(-1);
  }),
  __nextYear: esUtils.wrapPreventDefault(function () {
    this.__incYear(1);
  }),
  __today: esUtils.wrapPreventDefault(function () {
    let d1 = new Date(this.props.year, this.props.month - 1, 1);
    let d2 = new Date();
    this.__incYear(d2.getFullYear() - d1.getFullYear());
  }),
  render() {
    let {year, Calendars, Displaylists, include_other_companies, empire_mode} = this.props;
    let year_cal = esUtils.getIn(Calendars, [year, "calendar", year]) || {};
    let cal_details = esUtils.getIn(Calendars, [year, "details"]) || {};

    return dd.div({className: 'text-center'},
      dd.div({className: 'forward-backward-picker'},
        dd.button({className: 'pull-right btn btn-default btn-sm', style: {marginLeft: "0"}, onClick: this.__nextYear},
          dd.i({className: 'fa fa-angle-right'})
        ),
        dd.button({className: 'pull-right btn btn-default btn-sm', style: {marginRight: "0", marginLeft:"0"}, onClick: this.__today},
          "today"
        ),
        dd.button({className: 'pull-right btn btn-default btn-sm', style: {marginRight: "0"}, onClick: this.__prevYear},
          dd.i({className: 'fa fa-angle-left'})
        ),
        dd.span({className: 'title'}, year),
        dd.div({className: 'clearfix'})
      ),
      dd.div(null,
        _.map(_.range(1, 13), function (month) {
          return dd.div({
              key: year + '-' + month,
              style: {display: "inline-block", margin: 5, verticalAlign: "top"}
            },
            MiniCalendar({
              year,
              month,
              cal_data: year_cal[month],
              cal_details,
              Displaylists,
              include_other_companies,
              empire_mode
            })
          );
        })
      ),
      CalendarLegend()
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/YearCalendar.js